module.exports = __webpack_public_path__ + "static/media/1277_RoomService_Meal1_DeliveryTimes1_OrderSuccess.973cbe6e.png";